import { InventoryDetail } from '@cloudageone-schemas/InventoryDetail';
import { LookupEntity } from '@cloudageone-schemas/Lookup';
import { FilterConfig, FilterType } from 'app/shared/generic-grid/types/grid-filters.types';

export const InventoryFilters: FilterConfig<InventoryDetail>[] = [
	{
		dataField: 'spCktId',
		label: 'SP Service ID',
		type: FilterType.TEXTBOX
	},
	{
		dataField: 'internalId',
		label: 'Internal ID',
		type: FilterType.TEXTBOX
	},
	{
		dataField: 'vendor.id',
		label: 'Vendor',
		type: FilterType.VENDOR,
		multi: false
	},
	{
		dataField: 'installDate',
		label: 'Install Date',
		type: FilterType.RANGE_DATE
	},
	{
		dataField: 'siteA.id',
		label: 'Site A (Carrier Location)',
		type: FilterType.SITE,
		multi: false
	},
	{
		dataField: 'siteZ.id',
		label: 'Site Z (Customer Location)',
		type: FilterType.SITE,
		multi: false
	},
	{
		dataField: 'status.id',
		label: 'Status',
		type: FilterType.LOOKUP,
		entity: LookupEntity.INVENTORY_STATUS,
		multi: false
	},
	{
		dataField: 'inventoryCktType.id',
		label: 'Service Type',
		type: FilterType.LOOKUP,
		entity: LookupEntity.INVENTORY_CKT_TYPE,
		multi: false
	},
	{
		dataField: 'technology.id',
		label: 'Svc Tech',
		type: FilterType.LOOKUP,
		entity: LookupEntity.INVENTORY_TECHNOLOGY,
		multi: false
	},
	{
		dataField: 'circuitBandwidth.id',
		label: 'Service Bandwidth',
		type: FilterType.LOOKUP,
		entity: LookupEntity.CIRCUIT_BANDWIDTH,
		multi: false
	},
	{
		dataField: 'bandwidthMax.id',
		label: 'Port Bandwidth',
		type: FilterType.LOOKUP,
		entity: LookupEntity.CIRCUIT_BANDWIDTH,
		multi: false
	},
	{
		dataField: 'vlanId',
		label: 'VLAN ID',
		type: FilterType.TEXTBOX
	},
	{
		dataField: 'isCustomerProvidedAccess',
		label: 'Customer Provided Access',
		type: FilterType.CHECKBOX,
		options: [
			{ value: true, label: 'Yes' },
			{ value: false, label: 'No' }
		]
	},
	{
		dataField: 'type.id',
		label: 'Network Type',
		type: FilterType.LOOKUP,
		entity: LookupEntity.INVENTORY_TYPE,
		multi: false
	},
	{
		dataField: 'account.assignedUserId',
		label: 'Assigned User',
		type: FilterType.SECURITY_USER,
		multi: false
	},
	{
		dataField: 'account.subclient.id',
		label: 'Subclient',
		type: FilterType.LOOKUP,
		entity: LookupEntity.SUBCLIENT,
		multi: true
	},
	{
		dataField: 'customerInventory.customerCircuitId',
		label: 'Customer Service ID',
		type: FilterType.TEXTBOX
	},
	{
		dataField: 'account.id',
		label: 'Account',
		type: FilterType.ACCOUNT,
		multi: true
	},
	{
		dataField: 'customer.id',
		label: 'Customer',
		type: FilterType.CUSTOMER,
		multi: false
	},
	{
		dataField: 'discDate',
		label: 'Disconnect Date',
		type: FilterType.RANGE_DATE
	},
	{
		dataField: 'currency.id',
		label: 'Currency',
		type: FilterType.CURRENCY,
		multi: false
	},
	{
		dataField: 'estMrc',
		label: 'MRC',
		type: FilterType.NUMERIC,
		decimals: true
	},
	{
		dataField: 'estNrc',
		label: 'NRC',
		type: FilterType.NUMERIC,
		decimals: true
	},
	{
		dataField: 'id',
		label: 'System ID',
		type: FilterType.NUMERIC
	}
];
